/* Hearthside /cart page (2026-10-07). Reads and writes Shopify's own cart (/cart.js, /cart/change.js, /cart/update.js,
   /cart/add.js) and draws it like the tree-kit and Prism drawers. Config: window.HHCART from sections/hh-cart-page.liquid.
   Rules (the same as both drawers):
   - a Prism set line gets Edit + Remove, never a stepper — its price is the SET price, so quantity 2 of a Centerpiece would
     bill $179.98 for what the Prism page sells as The Pair at $149.99. Remove takes the set AND its Extra-figure lines.
   - an Extra-figure line with no set beside it is removed on load (it would otherwise sell one figure at $66.66).
   - Shipping protection / Lifetime warranty are one per order, and never ride alone.
   - tree kits keep a stepper: each pack is a real variant, so Shopify bills exactly qty × that pack's price.
   - Christmas in a Bottle (2026-10-20, config C.bottle from snippets/hh-bottle-json): a bottle line is one tier (The Single / The
     Pair / The Family Set), never quantity 2: 2 × The Single would bill more than The Pair. 2026-10-21 (Julian: "up and down quantity
     and delete, just like the Heirloom Tree kit"): it gets the kit stepper's look, but the number is BOTTLES and +/- swap the line's
     variant (1 The Single, 2 The Pair, 3 The Family Set) with the bottle page's add-first-then-clear write; plus is disabled at three,
     at one bottle the minus is the delete icon. A cart with more than one bottle line, or a line at quantity > 1, is made one line on
     load (all its bottles, capped at three). With The Pair or The Family Set, shipping protection is included free: it shows as a
     struck-through Free row, the paid add-on is not offered and tidy() (and the swap) take a paid one out. The Lifetime warranty is
     not offered on a cart that holds only bottles.
   - v28 (2026-10-21): the bottle line shows the bottle page drawer's free-gifts line ("Free: large-print recording guide", and
     " + spare battery pack + gift boxes for all three" with The Family Set), only while the bottle page's "Show the free gifts"
     setting is on (giftsOn: the mark bottle.js leaves in localStorage; none, or over a day old, = no gift line). */
(function () {
  'use strict';
  var C = window.HHCART; if (!C) return;
  var root = document.getElementById('hhc'); if (!root) return;
  var CART = C.cart || null, busy = false, err = null, FAIL = 'We couldn’t update your cart. Please try again.';

  function el(id) { return document.getElementById(id); }
  function esc(x) { return String(x == null ? '' : x).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(c) { return '$' + (Number(c || 0) / 100).toFixed(2); }
  function sku(it) { return String((it && it.sku) || ''); }
  function isPrism(it) { return sku(it).indexOf('HH-PRISM') === 0; }
  function isExtra(it) { return sku(it).indexOf('HH-PRISM-X') === 0; }
  function isSet(it) { return isPrism(it) && !isExtra(it); }
  /* Christmas in a Bottle lines: by product id (C.bottle), or the HH-BOTTLE SKU prefix if the config is missing */
  function isBottle(it) { return !!it && ((C.bottle && Number(it.product_id) === Number(C.bottle.productId)) || sku(it).indexOf('HH-BOTTLE') === 0); }
  function bottleTier(it) { return (C.bottle && C.bottle.tiers && C.bottle.tiers[String(it.variant_id)]) || null; }
  function bottleN(it) { var t = bottleTier(it); if (t && Number(t.n) > 0) return Number(t.n); var m = sku(it).match(/^HH-BOTTLE-(\d)/); return m ? Number(m[1]) : 1; }
  /* the bottle page's "Show the free gifts" setting, as bottle.js left it in localStorage ('1:<time>' / '0:<time>'). This page cannot
     read that section's setting, so a missing mark, a mark over a day old, or no storage means no gift line: /cart never promises a
     gift the bottle page has stopped offering. */
  function giftsOn() {
    try { var v = String(window.localStorage.getItem('hh_bottle_gifts') || '').split(':'); return v[0] === '1' && Date.now() - Number(v[1]) < 864e5; } catch (e) { return false; }
  }
  function giftsLine(n) {                          // the same words as the bottle page drawer, by bottles
    if (n < 2 || !giftsOn()) return '';
    return '<div class="hhci__v">Free: large-print recording guide' + (n >= 3 ? ' + spare battery pack + gift boxes for all three' : '') + '</div>';
  }
  function bottleSingle() { var ts = (C.bottle && C.bottle.tiers) || {}, k; for (k in ts) if (Number(ts[k].n) === 1) return Number(ts[k].price) || 0; return 0; }
  function freeBottle() { return items().some(function (it) { return isBottle(it) && bottleN(it) >= 2; }); }   // protection included free
  /* the bottle stepper's tiers, by bottles (1-3): { id, n, name, price, available } from C.bottle.tiers (keyed by variant id) */
  function botByN(n) {
    var ts = (C.bottle && C.bottle.tiers) || {}, k, t;
    for (k in ts) { t = ts[k]; if (t && Number(t.n) === Number(n)) return { id: Number(t.id || k), n: Number(t.n), name: String(t.name || ''), price: Number(t.price) || 0, available: t.available !== false }; }
    return null;
  }
  function botWord(n) { return n + (Number(n) === 1 ? ' bottle' : ' bottles'); }
  function botUp(n) { for (var j = n + 1; j <= 3; j++) { var t = botByN(j); if (t && t.available) return t; } return null; }   // a sold-out tier is skipped
  function botDown(n) { for (var j = n - 1; j >= 1; j--) { var t = botByN(j); if (t && t.available) return t; } return null; }
  function bottleStepHTML(it) {
    var bt = bottleTier(it), n = bt ? Number(bt.n) || 0 : 0; if (!n || !botByN(n)) return '';
    var up = botUp(n), dn = botDown(n), nx = botByN(n + 1), off = busy ? ' disabled' : '';
    var minus = dn ? '<button class="hhci__b" type="button" data-hhc-bstep="' + dn.n + '" data-dir="down" aria-label="Fewer bottles: switch to ' + esc(dn.name || botWord(dn.n)) + ', ' + botWord(dn.n) + '"' + off + '>&minus;</button>'
                   : '<button class="hhci__b" type="button" data-hhc-q="0" data-dir="down" aria-label="' + (n === 1 ? 'Remove your bottle' : 'Remove your bottles') + '"' + off + '><span class="ms" aria-hidden="true">delete</span></button>';
    var plus = up ? '<button class="hhci__b" type="button" data-hhc-bstep="' + up.n + '" data-dir="up" aria-label="More bottles: switch to ' + esc(up.name || botWord(up.n)) + ', ' + botWord(up.n) + '"' + off + '>+</button>'
                  : '<button class="hhci__b" type="button" data-dir="up" disabled aria-label="' + (n >= 3 || !nx ? 'Three bottles is the biggest set' : esc(nx.name || botWord(nx.n)) + ' is sold out right now') + '">+</button>';
    return '<span class="hhci__step" data-hhc-bottle>' + minus + '<input class="hhci__n" type="text" value="' + n + '" readonly tabindex="-1" aria-label="Bottles">' + plus + '</span>';
  }
  function bumpTag(it) {
    var b = C.bumps || {}, k;
    for (k in b) if (b[k] && Number(b[k].id) === Number(it.variant_id)) return k;
    return null;
  }
  function items() { return (CART && CART.items) || []; }

  /* the sale follows the STORE clock (America/Phoenix), never the shopper's */
  function storeDate() {
    try { return new Intl.DateTimeFormat('en-CA', { timeZone: C.tz || 'America/Phoenix', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date()); }
    catch (e) { var d = new Date(); return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
  }
  var today = storeDate(), saleOn = !!C.saleEnd && today <= C.saleEnd;
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var endLabel = today === C.saleEnd ? 'tonight' : (C.saleEnd ? MON[Number(C.saleEnd.slice(5, 7)) - 1] + ' ' + Number(C.saleEnd.slice(8, 10)) : '');

  function figCount(s) { var n = 0; String(s || '').split(' + ').forEach(function (p) { var m = p.match(/^(\d+) ×/); n += m ? Number(m[1]) : (p ? 1 : 0); }); return n; }
  /* per-unit "was" price in cents, only where it is really above the price.
     Prism lines: the bundle's regular price (figures × the single Centerpiece price) — the offer is permanent, not a dated sale.
     Everything else (the tree kits): the compare-at, only while the preseason sale is on. */
  function compareOf(it) {
    if (isBottle(it)) {                            // the same rule as the bottle page: n × the single price, or a lower compare-at
      var bt = bottleTier(it), single = bottleSingle(), n = bottleN(it), cmpAt = bt ? Number(bt.compare) || 0 : 0, price = Number(it.price);
      if (!single) return 0;
      var reg = n === 1 ? (cmpAt > price ? cmpAt : price) : ((cmpAt > price && cmpAt < n * single) ? cmpAt : n * single);
      return reg > price ? reg : 0;
    }
    if (isPrism(it) && Number(C.prismSingle) > 0) {
      var figs = isSet(it) ? (figCount(((it.options_with_values || [])[1] || {}).value) || 1) : 1;
      var reg = Math.round(figs * Number(C.prismSingle));
      return reg > Number(it.price) ? reg : 0;
    }
    if (!saleOn) return 0;
    var k = C.compare && C.compare[String(it.variant_id)];
    return k && k > Number(it.price) ? k : 0;
  }
  function thumb(src, w) {
    if (!src) return '';
    src = String(src); if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 160);
  }
  function figOf(name) { var f = String(name || '').replace(/^\d+ × /, '').trim().toLowerCase(); return (C.images && C.images[f]) || ''; }

  var ICON = {
    protection: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 2.8 4.6 5.9v5.3c0 4.6 3.1 8.4 7.4 9.9 4.3-1.5 7.4-5.3 7.4-9.9V5.9L12 2.8Z"/><path d="m8.9 11.9 2.2 2.2 4.1-4.4"/></svg>',
    warranty: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="14.6" r="5.4"/><path d="m8.6 9.6 -2.4-6.4h11.6l-2.4 6.4"/><path d="M12 12.2v4.8"/><path d="M10.2 14.6h3.6"/></svg>'
  };
  function upsells() {
    var hasSet = items().some(isSet), hasKit = items().some(function (it) { return !isPrism(it) && !bumpTag(it) && !isBottle(it); });
    var onlyBottles = items().some(isBottle) && !hasSet && !hasKit, free = freeBottle();
    var wb = hasSet && !hasKit ? 'If a light stops working or a part breaks, we replace it free.'
           : hasKit && !hasSet ? 'Snapped wire, cracked bead, dead light — we replace the part free.'
           : 'If a part breaks or a light stops working, we replace it free.';
    return [
      { tag: 'protection', name: 'Shipping protection', blurb: 'Lost, stolen or damaged in transit and we send another one.' },
      { tag: 'warranty', name: 'Lifetime warranty', blurb: wb }
    ].filter(function (u) {
      if (u.tag === 'protection' && free) return false;          // included free with 2 or 3 bottles
      if (u.tag === 'warranty' && onlyBottles) return false;     // never offered for the bottle
      return C.bumps && C.bumps[u.tag] && C.bumps[u.tag].id;
    });
  }

  function rowHTML(it) {
    var qty = Number(it.quantity) || 0, tag = bumpTag(it), cmp = compareOf(it), img = '', vt = '', ctl = '', title = it.product_title, extra = '';
    var was = cmp ? '<s>' + money(cmp * qty) + '</s>' : '';
    var opts = it.options_with_values || [];
    if (isBottle(it)) {
      var bt = bottleTier(it), bn = bottleN(it);
      vt = ((bt && bt.name) || ((it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '')) + ' · ' + bn + (bn === 1 ? ' bottle' : ' bottles') + (qty > 1 ? ' · × ' + qty : '');
      img = thumb(it.image);
      extra = giftsLine(bn);
      ctl = bottleStepHTML(it) || '<button class="hhci__rm" type="button" data-hhc-q="0" aria-label="Remove your bottles">Remove</button>';
    } else if (isSet(it)) {
      var setName = (opts[0] && opts[0].value) || '', figs = (opts[1] && opts[1].value) || '';
      var n = 0; figs.split(' + ').forEach(function (p) { var m = p.match(/^(\d+) ×/); n += m ? Number(m[1]) : (p ? 1 : 0); });
      var xtra = items().filter(isExtra).reduce(function (a, x) { return a + (Number(x.quantity) || 0); }, 0);
      vt = [setName, figs].filter(Boolean).join(' · ') + (xtra ? ' · set of ' + (n + xtra) : '') + (qty > 1 ? ' · × ' + qty : '');
      img = figOf(figs.split(' + ')[0]) || thumb(it.image);
      title = 'The Prism Tree';
      ctl = '<span class="hhci__acts">' + (C.routes.prism ? '<a class="hhci__rm" href="' + esc(C.routes.prism) + '" aria-label="Edit figures">Edit</a>' : '') +
            '<button class="hhci__rm" type="button" data-hhc-prism-rm aria-label="Remove your Prism Tree set">Remove</button></span>';
    } else if (isExtra(it)) {
      var fig = (opts[0] && opts[0].value) || it.variant_title || 'figure';
      var hasSet = items().some(isSet);
      title = 'The Prism Tree';
      vt = 'Extra ' + fig + (qty > 1 ? ' × ' + qty : '') + (hasSet ? ' · part of your set' : '');
      img = figOf(fig) || thumb(it.image);
      ctl = hasSet ? '' : '<button class="hhci__rm" type="button" data-hhc-prism-rm>Remove</button>';
    } else if (tag) {
      ctl = '<button class="hhci__rm" type="button" data-hhc-q="0" aria-label="Remove ' + esc(it.product_title) + '">Remove</button>';
    } else {
      vt = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
      img = thumb(it.image);
      ctl = '<span class="hhci__step">' +
              '<button class="hhci__b" type="button" data-hhc-q="' + (qty - 1) + '" aria-label="' + (qty > 1 ? 'Decrease quantity' : 'Remove this item') + '">' + (qty > 1 ? '&minus;' : '<span class="ms" aria-hidden="true">delete</span>') + '</button>' +
              '<input class="hhci__n" type="number" inputmode="numeric" min="1" max="10" value="' + qty + '" data-hhc-qty aria-label="Quantity">' +
              '<button class="hhci__b" type="button" data-hhc-q="' + (qty + 1) + '" aria-label="Increase quantity"' + (qty >= 10 ? ' disabled' : '') + '>+</button>' +
            '</span>';
    }
    var im = tag ? '<div class="hhci__im is-icon">' + ICON[tag] + '</div>'
                 : '<div class="hhci__im">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '<span class="ms" aria-hidden="true">redeem</span>') + '</div>';
    return '<div class="hhci" data-hhc-key="' + esc(it.key) + '">' + im +
             '<div class="hhci__d"><div class="hhci__t">' + esc(title) + '</div>' + (vt ? '<div class="hhci__v">' + esc(vt) + '</div>' : '') + extra +
             (ctl ? '<div class="hhci__c">' + ctl + '</div>' : '') + '</div>' +
             '<div class="hhci__p">' + money(it.final_line_price) + was + '</div>' +
           '</div>';
  }

  function render() {
    root.setAttribute('aria-busy', busy ? 'true' : 'false');
    var e = el('hhc-err'); if (e) { e.hidden = !err; e.textContent = err || ''; }
    var lines = el('hhc-lines'), list = items();
    if (!CART) { lines.innerHTML = '<p class="hhcart__load">Loading your cart&hellip;</p>'; return; }
    var sets = list.filter(isSet), extras = list.filter(isExtra), bumps = list.filter(function (it) { return !!bumpTag(it); }),
        bottles = list.filter(function (it) { return isBottle(it) && !bumpTag(it); }),
        kits = list.filter(function (it) { return !isPrism(it) && !bumpTag(it) && !isBottle(it); });
    var freeRow = '';
    if (freeBottle()) {                            // 2 or 3 bottles: shipping protection is part of the order, at no charge
      var fb = bottles.filter(function (it) { return bottleN(it) >= 2; })[0], fbt = fb && bottleTier(fb), pp = C.bumps && C.bumps.protection;
      freeRow = '<div class="hhci"><div class="hhci__im is-icon">' + ICON.protection + '</div><div class="hhci__d"><div class="hhci__t">Shipping protection</div>' +
                '<div class="hhci__v">Included free' + (fbt && fbt.name ? ' with ' + esc(fbt.name) : '') + '</div></div>' +
                '<div class="hhci__p">' + (pp && pp.price ? '<s>' + money(pp.price) + '</s>' : '') + 'Free</div></div>';
    }
    lines.innerHTML = list.length ? bottles.map(rowHTML).join('') + freeRow + sets.concat(extras, kits, bumps).map(rowHTML).join('') :
      '<div class="hhcart__empty"><span class="ms" aria-hidden="true">shopping_bag</span><p>Your cart is empty.</p>' +
      '<p class="s">The Prism Tree and the Heirloom Tree Kit are waiting.</p>' +
      '<a class="hhs-btn" href="/collections/all">Shop all products</a></div>';
    var shown = list.reduce(function (a, it) { return a + (isExtra(it) ? 0 : (Number(it.quantity) || 0)); }, 0);
    el('hhc-count').textContent = shown ? ' · ' + shown + (shown === 1 ? ' item' : ' items') : '';
    var badge = document.querySelector('.hhs-cartbtn');
    if (badge) {
      var nn = badge.querySelector('.n');
      if (shown) { if (!nn) { nn = document.createElement('span'); nn.className = 'n'; badge.appendChild(nn); } nn.textContent = shown; }
      else if (nn) nn.remove();
      badge.setAttribute('aria-label', shown ? 'Cart, ' + shown + (shown === 1 ? ' item' : ' items') : 'Cart');
    }
    function sv(it) { var c = compareOf(it); return c ? (c - Number(it.price)) * (Number(it.quantity) || 0) : 0; }
    var saved = list.reduce(function (a, it) { return a + sv(it); }, 0);
    var kitSaved = list.reduce(function (a, it) { return a + (isPrism(it) || isBottle(it) ? 0 : sv(it)); }, 0);   // the dated kit sale only: a bottle's bundle saving is permanent
    var botSaved = list.reduce(function (a, it) { return a + (isBottle(it) ? sv(it) : 0); }, 0);   // Julian 2026-10-20: a bottle saving always reads "Preseason sale", no end date
    el('hhc-total').textContent = money(Number(CART.items_subtotal_price) || 0);
    el('hhc-save').hidden = !(saved > 0); el('hhc-savev').textContent = '−' + money(saved);
    el('hhc-ship').textContent = list.length ? 'Free' : '—';
    var go = el('hhc-checkout'); go.disabled = !list.length || busy;
    var urg = el('hhc-urg');
    if (!list.length) urg.hidden = true;
    else {
      var preseason = saleOn && kitSaved > 0, tagSale = preseason || botSaved > 0;   // preseason alone adds the end date
      el('hhc-urgt').innerHTML = saved > 0 ? '<span class="hhcart__saletag"><span class="ms" aria-hidden="true">' + (tagSale ? 'local_offer' : 'redeem') + '</span> ' + (botSaved > 0 ? 'Early Black Friday deals' : (tagSale ? 'Preseason sale' : 'Bundle savings')) + '</span>' +
        '<span class="hhcart__saletxt">You’re saving <b>' + money(saved) + '</b> on this order' + (preseason ? ' — the preseason sale ends ' + esc(endLabel) : '') + '.</span>' : '';
      el('hhc-urgs').innerHTML = '<span class="ms" aria-hidden="true">check</span> Free shipping included on your order.';
      urg.hidden = false;
    }
    var ups = upsells(), have = {};
    bumps.forEach(function (b) { have[bumpTag(b)] = true; });
    el('hhc-upslist').innerHTML = ups.map(function (u) {
      var on = !!have[u.tag];
      return '<label class="hhup' + (on ? ' on' : '') + '" data-hhc-up="' + u.tag + '"><input type="checkbox"' + (on ? ' checked' : '') + (busy ? ' disabled' : '') + '>' +
             '<span class="hhup__ico">' + ICON[u.tag] + '</span><span class="hhup__box"><span class="ms" aria-hidden="true">check</span></span>' +
             '<span class="hhup__t"><b>' + u.name + '</b><small>' + esc(u.blurb) + '</small></span><span class="hhup__p">+' + money(C.bumps[u.tag].price) + '</span></label>';
    }).join('');
    el('hhc-ups').hidden = !(sets.length + kits.length + bottles.length) || !ups.length;
  }

  /* ---------- server calls: one write in flight, the cart always re-read from Shopify ---------- */
  function post(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) });
  }
  function okOrThrow(r) {
    if (r.ok) return r.json();
    return r.json().catch(function () { return null; }).then(function (j) { throw new Error((j && (j.description || j.message)) || FAIL); });
  }
  function refresh() {
    return fetch(C.routes.cartjs, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(FAIL); return r.json(); })
      .then(function (c) { CART = c; return c; });
  }
  function update(upd) { return post(C.routes.update, { updates: upd }).then(okOrThrow).then(function (c) { CART = c; return c; }); }
  /* add-ons never ride alone; an Extra figure never rides without its set; an add-on is one per order */
  function tidy() {
    var list = items(), upd = {}, any = false;
    var hasSet = list.some(isSet), hasMain = list.some(function (it) { return !bumpTag(it) && !isExtra(it); }), free = freeBottle();
    list.forEach(function (it) {
      if (isExtra(it) && !hasSet) { upd[it.key] = 0; any = true; }
      else if (bumpTag(it) && !hasMain) { upd[it.key] = 0; any = true; }
      else if (bumpTag(it) === 'protection' && free) { upd[it.key] = 0; any = true; }   // included free with 2 or 3 bottles: never charged
      else if (bumpTag(it) && Number(it.quantity) > 1) { upd[it.key] = 1; any = true; }
    });
    return any ? update(upd) : Promise.resolve(CART);
  }
  function run(p, after) {
    if (busy) return;
    busy = true; err = null; render();
    p().then(tidy).catch(function (e) { err = (e && e.message) || FAIL; return refresh().catch(function () { }); })
      .then(function () { busy = false; render(); if (after) after(); });
  }
  function refocus(key) {
    var row = key && el('hhc-lines').querySelector('[data-hhc-key="' + String(key).replace(/"/g, '') + '"]');
    var b = row && row.querySelector('.hhci__b:not([disabled]), .hhci__rm');
    var go = el('hhc-checkout'), shop = el('hhc-lines').querySelector('.hhcart__empty a');
    var t = b || (go && !go.disabled ? go : null) || shop || el('hhc-h1');   // never drop focus onto <body>
    try { if (t) t.focus({ preventScroll: true }); } catch (e) { }
  }
  function changeLine(key, q) {
    q = Math.round(Number(q)); if (!isFinite(q)) { render(); return; }
    q = Math.max(0, Math.min(10, q));
    run(function () { return post(C.routes.change, { id: String(key), quantity: q }).then(okOrThrow).then(function (c) { CART = c; }); },
        function () { refocus(key); });
  }
  /* the bottle swap = the bottle page's write (bottle.js syncSet): on a FRESH cart add the new tier first (with "Shipping protection:
     Included free" for 2 or 3 bottles), then ONE /cart/update.js clearing every other bottle line and, for 2 or 3 bottles, a paid
     protection; a refused add changes nothing. Then re-read: one bottle line of that tier at quantity 1, at this page's price. */
  var PROP_K = 'Shipping protection', PROP_V = 'Included free', MOVED = 'Prices just updated — refreshing the page.';
  function hasFree(it) { return !!(it && it.properties && it.properties[PROP_K] === PROP_V); }
  function bottleLines() { return items().filter(function (it) { return isBottle(it) && !bumpTag(it); }); }
  function swapBottle(n) {
    var t = botByN(n), free = Number(n) >= 2;
    if (!t) return Promise.reject(new Error(FAIL));
    return refresh().then(function () {
      var have = bottleLines(), keep = have.filter(function (it) { return Number(it.variant_id) === t.id && hasFree(it) === free; })[0] || null;
      var upd = {}, need = false;
      have.forEach(function (it) { if (it !== keep) { upd[it.key] = 0; need = true; } });
      if (keep && Number(keep.quantity) !== 1) { upd[keep.key] = 1; need = true; }
      if (free) items().forEach(function (it) { if (bumpTag(it) === 'protection') { upd[it.key] = 0; need = true; } });
      var item = { id: t.id, quantity: 1 };
      if (free) { item.properties = {}; item.properties[PROP_K] = PROP_V; }
      var step = keep ? Promise.resolve() : post(C.routes.add, { items: [item] }).then(okOrThrow);
      return step.then(function () { return need ? post(C.routes.update, { updates: upd }).then(okOrThrow) : null; }).then(refresh);
    }).then(function (c) {
      var b = bottleLines();
      if (b.length !== 1 || Number(b[0].variant_id) !== t.id || Number(b[0].quantity) !== 1 || hasFree(b[0]) !== free) throw new Error(FAIL);
      if (Number(b[0].original_line_price) !== t.price) { var er = new Error(MOVED); er.moved = true; throw er; }
      return c;
    });
  }
  function stepBottle(n, dir) {                    // one write in flight: the stepper is drawn disabled, a double click is one swap
    if (busy || !botByN(n)) return;
    var moved = false;
    run(function () { return swapBottle(n).catch(function (e) { if (e && e.moved) moved = true; throw e; }); },
        function () {
          if (moved) { setTimeout(function () { location.reload(); }, 1200); return; }
          var st = el('hhc-lines').querySelector('[data-hhc-bottle]');   // the line was re-drawn under a new key: focus the same button
          var b = st && (st.querySelector('[data-dir="' + dir + '"]:not([disabled])') || st.querySelector('.hhci__b:not([disabled])'));
          if (b) { try { b.focus({ preventScroll: true }); } catch (e) { } } else refocus(null);
        });
  }
  /* a bottle line is ONE line at quantity 1: a cart holding more (quantity 2 from an old page, or two lines after a failed clear)
     becomes the tier for all its bottles, capped at three (Single x2 -> The Pair, Pair x2 -> The Family Set). Silent, on load
     only; never more bottles than the cart held, never a higher bill. */
  function normalizeBottles() {
    var b = bottleLines(), n = 0, known = true;
    if (!b.length || (b.length === 1 && Number(b[0].quantity) === 1)) return Promise.resolve(CART);
    b.forEach(function (it) { var bt = bottleTier(it); if (bt && Number(bt.n) > 0) n += Number(bt.n) * (Number(it.quantity) || 0); else known = false; });
    var to = botByN(Math.min(3, n));
    if (!known || !to || !to.available) return Promise.resolve(CART);
    return swapBottle(to.n).catch(function () { return refresh().catch(function () { }); });
  }
  function load() { return refresh().then(normalizeBottles); }
  function removePrism() {
    var upd = {}; items().filter(isPrism).forEach(function (it) { upd[it.key] = 0; });
    if (!Object.keys(upd).length) return;
    run(function () { return update(upd); }, function () { refocus(null); });
  }
  function toggleUpsell(tag, want) {
    var b = C.bumps && C.bumps[tag]; if (!b) return;
    var line = items().filter(function (it) { return bumpTag(it) === tag; })[0];
    if (want && !line) run(function () { return post(C.routes.add, { items: [{ id: Number(b.id), quantity: 1 }] }).then(okOrThrow).then(refresh); },
                           function () { var x = el('hhc-upslist').querySelector('[data-hhc-up="' + tag + '"] input'); if (x) try { x.focus({ preventScroll: true }); } catch (e) { } });
    else if (!want && line) changeLine(line.key, 0);
    else render();
  }

  root.addEventListener('click', function (e) {
    var t = e.target; if (!t.closest) return;
    var bs = t.closest('[data-hhc-bstep]');        // the bottle stepper (its delete is a plain data-hhc-q="0")
    if (bs) { if (!busy && !bs.disabled) stepBottle(Number(bs.getAttribute('data-hhc-bstep')), bs.getAttribute('data-dir')); return; }
    var q = t.closest('[data-hhc-q]');
    if (q) { if (busy) return; var row = q.closest('[data-hhc-key]'); if (row) changeLine(row.getAttribute('data-hhc-key'), q.getAttribute('data-hhc-q')); return; }
    if (t.closest('[data-hhc-prism-rm]')) { if (!busy) removePrism(); return; }
    if (t.closest('#hhc-checkout')) {
      if (busy || !items().length) return;
      var go = el('hhc-checkout'); go.disabled = true; go.innerHTML = '<span class="ms" aria-hidden="true">lock</span> Taking you to checkout…';
      location.href = C.routes.checkout; return;
    }
  });
  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches && t.matches('[data-hhc-qty]')) {
      var row = t.closest('[data-hhc-key]'), v = String(t.value).trim();
      if (!row || busy || v === '' || !isFinite(Number(v)) || Number(v) < 1) { render(); return; }   // a cleared box never deletes the line
      changeLine(row.getAttribute('data-hhc-key'), v); return;
    }
    var up = t.closest && t.closest('[data-hhc-up]');
    if (up && t.type === 'checkbox') { if (busy) { render(); return; } toggleUpsell(up.getAttribute('data-hhc-up'), t.checked); }
  });
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var go = el('hhc-checkout'); if (go) go.innerHTML = '<span class="ms" aria-hidden="true">lock</span> Checkout';
    busy = false; run(load);
  });

  render();
  run(load);   // the server-rendered cart is a first paint only; Shopify's /cart.js is the truth, then one bottle line, then tidy()
})();

